import React from "react";

export default function PromoTwo() {
  return (
    <>
      <section className="promo-section mt-5 ptb-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-10">
              <div className="section-heading mb-5">
              
                <h2 className="mb-6" style={{color:'#145580'}}>
                Who Are We</h2>
              </div>
             
            </div>
         
          
          </div>
          <p>The Sustainable Institute is a select group of highly trained researchers consultants
with great expertise and experience in business planning and development. Its
mission is related to helping public and private institutions, companies and non-
governmental organizations meet the economic and technological challenges of the
21st century. We create business environments that support innovation in designing
and delivering products and services, follow systemic approaches in managing and
training human resources, and excel in respecting cultural differences. All our actions
and activities are guided by transparency and ethics principles.</p>
          <p>We are group of partners who chose to work around the globe. We seek challenging
opportunities in order to develop new businesses, to create new trades, to implement
new high-technology projects, to support life-long learning for human resources. Our
interdisciplinary approach in project planning and implementation makes us unique in
the consulting ecosystem.</p>
        </div>
      </section>
    </>
  );
}
